"use client";

import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
import { ADSTERRA_CONFIG, getAdsterraTenant } from "@/config/adsterra";
interface AdsterraSocialBarProps {
  domain: string;
}
export function AdsterraSocialBar(t0) {
  const $ = _c(2);
  const {
    domain
  } = t0;
  const tenant = getAdsterraTenant(domain);
  const socialBarSrc = ADSTERRA_CONFIG[tenant]?.socialBar;
  if (!socialBarSrc) {
    return null;
  }
  let t1;
  if ($[0] !== socialBarSrc) {
    t1 = <Script src={socialBarSrc} strategy="lazyOnload" />;
    $[0] = socialBarSrc;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}